import React from 'react';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import { useTheme } from '@mui/material/styles';
import { useViewports } from '../../../hooks/useViewports';
import { SubMenuSection } from '../SubMenuSection';
import { MENU_LAYOUT } from '../types';
import * as S from './styles';
const SubMenuContainer = ({ subMenus, clickCallback }) => {
    const theme = useTheme();
    const { isMobile } = useViewports(theme);
    if (typeof subMenus === 'undefined') {
        return null;
    }
    const { top, main, sidebar, bottom, layout = MENU_LAYOUT.Default } = subMenus;
    return (React.createElement(S.Wrapper, { "$layout": layout, "$isMobile": isMobile, onClick: clickCallback },
        !isEmpty(compact(top)) ? (React.createElement("div", { className: "top" },
            React.createElement(SubMenuSection, { items: top }))) : null,
        React.createElement("div", { className: "middle" },
            !isEmpty(compact(main)) ? (React.createElement("div", { className: "main" },
                React.createElement(SubMenuSection, { items: main }))) : null,
            !isEmpty(compact(sidebar)) ? (React.createElement("div", { className: "sidebar" },
                React.createElement(SubMenuSection, { items: sidebar }))) : null),
        !isEmpty(compact(bottom)) ? (React.createElement("div", { className: "bottom" },
            React.createElement(SubMenuSection, { items: bottom }))) : null));
};
export default SubMenuContainer;
//# sourceMappingURL=index.js.map